import React from "react"
import {useTranslation} from "react-i18next"
import {IonBadge} from "@ionic/react"

const BadgeUserIsYou: React.FC = () => {

    const {t} = useTranslation()

    return (
        <IonBadge color="bc-blue" className="ion-hide-md-down" slot="end" style={
            {
                'color': 'white',
                'fontWeight': 500,
                'minWidth': '100px',
                '--padding-top': '6px', '--padding-bottom': '6px',
                '--padding-start': '8px', '--padding-end': '8px',
                'marginRight': '6px'
            }
        }>
            {t('common.you')}
        </IonBadge>
    )
}

export default BadgeUserIsYou